import { useState } from 'react';
import { axiosApi } from '../../api/setupApi';

// Fallback endpoint list to handle API route differences across environments
const ADD_ENDPOINTS = [
  '/convergence/insert',
  '/convergence/upsert',
  '/convergence/add',
  '/convergence'
];

// Normalize form data into the upsert payload shape expected by the bulk endpoint
const toUpsertRows = (data) => [{
  id: data.id ?? null,
  type: data.type ?? '',
  program: data.program ?? '',
  indicator: data.indicator ?? '',
  status_2024: data.status_2024 ?? data.status2024 ?? '',
  target_2025: data.target_2025 ?? data.target2025 ?? '',
  accom_jan: data.accom_jan ?? data.months?.[0] ?? '',
  accom_feb: data.accom_feb ?? data.months?.[1] ?? '',
  accom_mar: data.accom_mar ?? data.months?.[2] ?? '',
  accom_apr: data.accom_apr ?? data.months?.[3] ?? '',
  accom_may: data.accom_may ?? data.months?.[4] ?? '',
  accom_jun: data.accom_jun ?? data.months?.[5] ?? '',
  accom_jul: data.accom_jul ?? data.months?.[6] ?? '',
  accom_aug: data.accom_aug ?? data.months?.[7] ?? '',
  accom_sep: data.accom_sep ?? data.months?.[8] ?? '',
  accom_oct: data.accom_oct ?? data.months?.[9] ?? '',
  accom_nov: data.accom_nov ?? data.months?.[10] ?? '',
  accom_dec: data.accom_dec ?? data.months?.[11] ?? '',
  total: data.total ?? '',
  status_date: data.status_date ?? data.statusToDate ?? '',
  remarks: data.remarks ?? ''
}];

const useAddConvergence = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const addConvergence = async (data) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    const tried = [];
    let result = null;

    for (const endpoint of ADD_ENDPOINTS) {
      tried.push(endpoint);
      try {
        const payload = endpoint.includes('upsert') ? toUpsertRows(data) : data;
        const response = await axiosApi.post(endpoint, payload);
        setSuccess(true);
        result = response.data;
        break;
      } catch (err) {
        const status = err?.response?.status;
        // Continue on 404/405; treat others as fatal
        const recoverable = !status || [404, 405].includes(status);
        if (!recoverable) {
          setError(err.message);
          console.error('Add Convergence Error (fatal):', err);
          break;
        }
        // If this was the last endpoint, surface the error
        if (endpoint === ADD_ENDPOINTS[ADD_ENDPOINTS.length - 1]) {
          setError(`All add endpoints failed (${tried.join(', ')}): ${err.message}`);
        }
      }
    }
    setLoading(false);
    return result;
  };

  return {
    addConvergence,
    loading,
    error,
    success,
  };
};

export default useAddConvergence;
